import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-penetration-page',
  templateUrl: './penetration-page.component.html',
  styleUrls: ['./penetration-page.component.scss']
})
export class PenetrationPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
